import React, { useEffect, useState } from 'react'
import FilterButton from '../../common-components/FilterButton'
import InputBox from '../../common-components/InputBox'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useNavigate, useSearchParams } from 'react-router-dom'
import useValidator from '../../utilities/useValidator'
import Swal from 'sweetalert2'
import { useDispatch, useSelector } from 'react-redux'
import { hideLoader, showLoader } from '../../redux-store/loaderReducer'
import { communication } from '../../services/communication'
import Loader from '../../utilities/Loader'

const UpdateOrganizer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loader = useSelector((state) => state.loaderReducer.loaderState);
  const [organizerId] = useSearchParams();
  const [validator, showValidationMessage] = useValidator();
  const [accessValidator, showAccessValidationMessage] = useValidator();
  const [designationList, setDesignationList] = useState([]);
  const [organizerData, setOrganizerData] = useState(
    {
      name: "",
      mobile: "",
      altMobile: "",
      address: "",
      voterId: "",
      city: "",
      designationId: "",
    }
  );

  const [boothData, setBoothData] = useState(
    {
      booth: "",
      boothNo: "",
      page: []
    }
  )

  const [boothAccess, setBoothAccess] = useState([]);


  //fetch organizer detail by id
  const fetchOrganizerDetail = async () => {
    try {
      const responseFromServer = await communication.getOrganizerDetailByID(organizerId.get("organizerId"));
      if (responseFromServer?.data?.status === "SUCCESS") {
        setOrganizerData(responseFromServer?.data?.isOrganizerExist);
        setBoothAccess(responseFromServer?.data?.isOrganizerExist?.boothAccess);
        fetchDesignationList();
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        navigate("/login");
      } else {
        setOrganizerData([]);
      }
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error?.message, icon: "error" });
    }
  }

  //add access
  const addAccess = () => {
    try {
      if (!accessValidator.allValid()) {
        showAccessValidationMessage(true);
        return false
      }
      setBoothAccess([...boothAccess, boothData]);
      setBoothData({ booth: "", boothNo: "", page: [] });
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error?.message, icon: "error" });
    }
  }

  //delete booth access
  const deleteBoothAccess = (index) => {
    const newBoothArray = boothAccess?.filter((ele, id) => index !== id);
    setBoothAccess(newBoothArray);
  }

  //get all designation list
  const fetchDesignationList = async () => {
    try {
      const responseFromServer = await communication.getAllDesignations();
      if (responseFromServer?.data?.status === "SUCCESS") {
        setDesignationList(responseFromServer?.data?.designation);
      } else if (responseFromServer?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: responseFromServer?.data?.message, icon: "warning" });
        navigate("/login");
      } else {
        setDesignationList([]);
      }
    } catch (error) {
      Swal.fire({ text: error?.response?.data?.message || error?.message, icon: "error" });
    }
  }

  //add organizer
  const updateOrganizer = async () => {
    try {
      if (!validator.allValid()) {
        showValidationMessage(true);
        return false
      }
      if (boothAccess?.length === 0) {
        Swal.fire({ text: "Add at least one booth access", icon: "warning" });
        return false;
      }
      const dataToSend = {
        organizerId: organizerId.get("organizerId"),
        name: organizerData.name,
        mobile: Number(organizerData.mobile),
        altMobile: Number(organizerData.altMobile),
        address: organizerData.address,
        voterId: organizerData.voterId,
        city: organizerData.city,
        designationId: organizerData.designationId,
        boothAccess
      }
      dispatch(showLoader());
      const serverResponse = await communication.updateOrganizer(dataToSend);
      if (serverResponse?.data?.status === "SUCCESS") {
        Swal.fire({ text: serverResponse?.data?.message, icon: "success" });
        navigate(-1);
      } else if (serverResponse?.data?.status === "JWT_INVALID") {
        Swal.fire({ text: serverResponse?.data?.message, icon: "warning" });
        navigate("/login");
      } else {
        Swal.fire({ text: serverResponse?.data?.message, icon: "warning" });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      Swal.fire({ text: error?.response?.data?.message || error?.message, icon: "error" });
    }
  }

  useEffect(() => {
    fetchOrganizerDetail();
  }, []);

  return (
    <>
      {loader === true ?
        <Loader />
        :
        <>
          <div className="top_header">
            <div className="title">Update Organizer</div>
          </div>
          <section>
            <div className="form_wrapper_main">
              <div className="card_wrapper">
                <div className="card_header">
                  <div className="title">
                    <h5>Update Organizer</h5>
                  </div>
                  <div className="close_button" onClick={() => navigate("/dashboard/organization-management")}>
                    <FontAwesomeIcon icon={faXmark} />
                  </div>
                </div>
                <div className="card_body">
                  <div className="row">
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Name</label>
                        <InputBox type="text" name="name" value={organizerData.name} onChange={(event) => setOrganizerData({ ...organizerData, name: event.target.value })} placeholder="Enter Full Name" />
                        {validator.message("name", organizerData.name, "required", {
                          messages: {
                            required: "Full Name is required"
                          }
                        })}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Mobile Number</label>
                        <InputBox type="number" name="mobile" value={organizerData.mobile} onChange={(event) => setOrganizerData({ ...organizerData, mobile: event.target.value })} placeholder="Enter Mobile Number" />
                        {validator.message("mobile", organizerData.mobile, "required|numeric|min:10|max:10", {
                          messages: {
                            required: "Mobile Number is required"
                          }
                        })}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Alternate Number</label>
                        <InputBox type="number" name="altMobile" value={organizerData.altMobile} onChange={(event) => setOrganizerData({ ...organizerData, altMobile: event.target.value })} placeholder="Enter Alternate Number" />
                        {validator.message("mobile", organizerData.altMobile, "numeric|min:10|max:10", {
                          messages: {
                            required: "Alternate Number is required"
                          }
                        })}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Village/City</label>
                        <InputBox type="text" name="city" value={organizerData.city} onChange={(event) => setOrganizerData({ ...organizerData, city: event.target.value })} placeholder="Enter Alternate Number" />
                        {validator.message("city", organizerData.city, "required", {
                          messages: {
                            required: "City is required"
                          }
                        })}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Voter ID</label>
                        <InputBox type="text" name="voterId" value={organizerData.voterId} onChange={(event) => setOrganizerData({ ...organizerData, voterId: event.target.value })} placeholder="Enter Alternate Number" />
                        {validator.message("voterId", organizerData.voterId, "required", {
                          messages: {
                            required: "Voter ID is required"
                          }
                        })}
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="input_box_wrapper">
                        <label>Designation</label>
                        <select name="designationId" onChange={(event) => setOrganizerData({ ...organizerData, designationId: event.target.value })} className="form-select designation_select_box">
                          <option value="">Select Designation</option>
                          {designationList?.map((designation, index) => {
                            return (
                              <option value={designation?._id} selected={designation?._id === organizerData.designationId} key={index}>{designation?.name}</option>
                            );
                          })}
                        </select>
                        {validator.message("designationId", organizerData.designationId, "required", {
                          messages: {
                            required: "Designation is required"
                          }
                        })}
                      </div>
                    </div>
                    <div className="col-8">
                      <div className="input_box_wrapper">
                        <label>Address</label>
                        <textarea className="form-control" value={organizerData.address} onChange={(event) => setOrganizerData({ ...organizerData, address: event.target.value })} placeholder="Enter Address"></textarea>
                        {validator.message("address", organizerData.address, "required", {
                          messages: {
                            required: "Address is required"
                          }
                        })}
                      </div>
                    </div>

                  </div>
                  <div className="booth_access_wrapper">
                    <div className="row">
                      <div className="col-3">
                        <div className="input_box_wrapper">
                          <label>Booth Name</label>
                          <InputBox type="text" name="booth" value={boothData.booth} onChange={(event) => setBoothData({ ...boothData, booth: event.target.value })} placeholder="Enter Booth Name" />
                          {accessValidator.message("booth", boothData.booth, "required", {
                            messages: {
                              required: "Booth Name is required"
                            }
                          })}
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="input_box_wrapper">
                          <label>Booth Number</label>
                          <InputBox type="text" name="boothNo" value={boothData.boothNo} onChange={(event) => setBoothData({ ...boothData, boothNo: event.target.value })} placeholder="Enter Booth Name" />
                          {accessValidator.message("boothNo", boothData.boothNo, "required", {
                            messages: {
                              required: "Booth Number is required"
                            }
                          })}
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="input_box_wrapper">
                          <label>Page Number</label>
                          <InputBox type="text" name="page" value={boothData.page} onChange={(event) => setBoothData({ ...boothData, page: event.target.value.split(",") })} placeholder="Enter page Number ex: 1,2,3" />
                          {accessValidator.message("page", boothData.page, "required", {
                            messages: {
                              required: "Page Number is required"
                            }
                          })}
                        </div>
                      </div>
                    </div>
                    <button className="add_access_button" onClick={() => addAccess()}>Add Access</button>
                  </div>
                  {boothAccess?.map((boothDetail, index) => {
                    return (
                      <div className="booth_access_wrapper" key={index}>
                        <div className="row">
                          <div className="col-3">
                            <div className="input_box_wrapper">
                              <input type="text" name="booth" value={boothDetail?.booth} className="form-control" disabled />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="input_box_wrapper">
                              <input type="text" name="boothNo" value={boothDetail?.boothNo} className="form-control" disabled />
                            </div>
                          </div>
                          <div className="col-3">
                            <div className="input_box_wrapper">
                              <input type="text" name="page" value={boothDetail?.page?.map((pageNumber) => {
                                return (
                                  pageNumber?.length > 1 ? `${pageNumber},` : pageNumber
                                );
                              })} className="form-control" disabled />
                            </div>
                          </div>
                        </div>
                        <FontAwesomeIcon icon={faTrash} className="trash_button" onClick={() => deleteBoothAccess(index)} />
                      </div>
                    );
                  })}

                  <div className="submit_button_wrapper">
                    <FilterButton name="Update" onClick={() => updateOrganizer()} />
                  </div>
                </div>
              </div>
            </div>
          </section>

        </>
      }
    </>
  )
}

export default UpdateOrganizer